"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
require("../sass/style.scss");
var newCard_1 = require("./newCard");
window.onload = function () {
    var modalId = window.location.hash.substring(1);
    if (modalId && document.getElementById(modalId)) {
        //@ts-ignore
        document.getElementById(modalId).style.visibility = "visible";
        //@ts-ignore
        document.getElementById(modalId).style.opacity = 1;
    }
};
document.addEventListener("DOMContentLoaded", function () {
    function createSpeakerCard(data, day) {
        return (0, newCard_1.newCardTypeOne)(data, day);
    }
    var cardContainer = document.querySelector(".card-container");
    var cardContainer2 = document.querySelector(".card-container-2");
    var cardContainer3 = document.querySelector(".card-container-3");
    axios_1.default.get("./mock/day.json").then(function (res) {
        if (cardContainer !== null) {
            if (res.data.data.day1.length > 0) {
                res.data.data.day1.forEach(function (data) {
                    cardContainer.innerHTML += createSpeakerCard(data, "day1");
                    var speakercard = document.querySelector(".new-speaker-".concat(data.id, "-day1"));
                    //@ts-ignore
                    data.speaker_profile.forEach(function (speaker) { speakercard === null || speakercard === void 0 ? void 0 : speakercard.innerHTML += (0, newCard_1.speakerCardUI)(speaker); });
                    var newModalSpeaker = document.querySelector(".new-modal-profile-card-".concat(data.id, "-day1"));
                    //@ts-ignore
                    data.speaker_profile.forEach(function (speaker) { newModalSpeaker === null || newModalSpeaker === void 0 ? void 0 : newModalSpeaker.innerHTML += (0, newCard_1.speakerModalProfileCardUI)(speaker); });
                });
            }
        }
        if (cardContainer2 !== null) {
            if (res.data.data.day2.length > 0) {
                res.data.data.day2.forEach(function (data) {
                    cardContainer2.innerHTML += createSpeakerCard(data, "day-2");
                    var speakercard = document.querySelector(".new-speaker-".concat(data.id, "-day-2"));
                    //@ts-ignore
                    data.speaker_profile.forEach(function (speaker) { speakercard === null || speakercard === void 0 ? void 0 : speakercard.innerHTML += (0, newCard_1.speakerCardUI)(speaker); });
                    var newModalSpeaker = document.querySelector(".new-modal-profile-card-".concat(data.id, "-day-2"));
                    //@ts-ignore
                    data.speaker_profile.forEach(function (speaker) { newModalSpeaker === null || newModalSpeaker === void 0 ? void 0 : newModalSpeaker.innerHTML += (0, newCard_1.speakerModalProfileCardUI)(speaker); });
                });
            }
        }
        if (cardContainer3 !== null) {
            if (res.data.data.day3.length > 0) {
                res.data.data.day3.forEach(function (data) {
                    cardContainer3.innerHTML += createSpeakerCard(data, "day-3");
                    var speakercard = document.querySelector(".new-speaker-".concat(data.id, "-day-3"));
                    //@ts-ignore
                    data.speaker_profile.forEach(function (speaker) { speakercard === null || speakercard === void 0 ? void 0 : speakercard.innerHTML += (0, newCard_1.speakerCardUI)(speaker); });
                    var newModalSpeaker = document.querySelector(".new-modal-profile-card-".concat(data.id, "-day-3"));
                    //@ts-ignore
                    data.speaker_profile.forEach(function (speaker) { newModalSpeaker === null || newModalSpeaker === void 0 ? void 0 : newModalSpeaker.innerHTML += (0, newCard_1.speakerModalProfileCardUI)(speaker); });
                });
            }
        }
    });
    var companyImageCollection = document.querySelector('.company-image-collection');
    //@ts-ignore
    companyImageCollection === null || companyImageCollection === void 0 ? void 0 : companyImageCollection.innerHTML = '';
    axios_1.default.get("./mock/supportimage.json").then(function (res) {
        if (companyImageCollection !== null) {
            res.data.forEach(function (img, index) {
                //@ts-ignore
                companyImageCollection === null || companyImageCollection === void 0 ? void 0 : companyImageCollection.innerHTML += "\n           <div class=\"company-image-wrapper\">\n             <img\n             src=\"".concat(img.image_path, "\"\n             class=\"company-image\"\n             alt=\"").concat(img.image_path, "\"\n             />\n           </div\n         ");
            });
        }
    });
    var resizeHandler = function () {
        var winWid = document.documentElement.clientWidth;
        var hig = document.documentElement.clientHeight > 713
            ? document.documentElement.clientHeight
            : 713;
        var wid = document.documentElement.clientWidth;
        wid = wid > 2150 ? 2150 : wid;
        hig = winWid < hig * 1.6 ? wid * (900 / 1434) : hig;
        var scl = 1434 / 900;
        var conWid = hig * scl;
        var conHig = hig;
        var tgt = document.getElementById("home");
        if (winWid > 768) {
            if (tgt && tgt.style) {
                tgt.style.width = conWid + "px";
                tgt.style.height = conHig + "px";
                tgt.style.marginLeft = (wid - conWid) / 2 + "px";
            }
        }
        else {
            if (tgt && tgt.style) {
                tgt.style.width = "auto";
                tgt.style.height = "";
                tgt.style.marginLeft = "0px";
            }
        }
        console.log('conHig:', conHig);
        if (conHig >= 1315 || conWid > 2150) {
            if (tgt && tgt.style) {
                tgt.style.marginBottom = '150px';
            }
        }
        else {
            if (tgt && tgt.style) {
                tgt.style.marginBottom = 'auto';
            }
        }
        var contact = document.getElementById("contact");
        var innerWid = document.documentElement.clientWidth > 2150
            ? document.documentElement.clientWidth
            : 2150;
        if (innerWid > 2150) {
            if (contact && contact.style) {
                contact.style.marginLeft = "-" + (innerWid - 2150) / 2 + "px";
                contact.style.width = innerWid + "px";
            }
        }
        else {
            if (contact && contact.style) {
                contact.style.marginLeft = "0px";
                contact.style.width = "auto";
            }
        }
    };
    window.addEventListener("resize", resizeHandler);
    resizeHandler();
    window.addEventListener("scroll", function () {
        //add active class when scroll is 100px from top
        if (window.scrollY > 100) {
            document.querySelector(".scrolltop-btn").classList.add("active");
            document.querySelector("#g_hdr").classList.add("active");
            document.querySelector("#hdr_logo").classList.add("active");
        }
        else {
            document.querySelector(".scrolltop-btn").classList.remove("active");
            document.querySelector("#g_hdr").classList.remove("active");
            document.querySelector("#hdr_logo").classList.remove("active");
        }
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
            // Check the bottom of the page
            document.querySelector(".scrolltop-btn").classList.remove("active");
        }
    });
    var items = document.querySelectorAll(".accordion button");
    items.forEach(function (item) { return item.addEventListener("click", toggleAccordion); });
    function toggleAccordion() {
        var itemToggle = this.getAttribute("aria-expanded");
        for (var i = 0; i < items.length; i++) {
            items[i].setAttribute("aria-expanded", "false");
        }
        if (itemToggle == "false") {
            this.setAttribute("aria-expanded", "true");
        }
    }
    var toggleImagesBtn = document.getElementById('toggleImagesBtn');
    var isImageViewMore = false;
    toggleImagesBtn === null || toggleImagesBtn === void 0 ? void 0 : toggleImagesBtn.addEventListener('click', function () {
        isImageViewMore = !isImageViewMore;
        var toggleImagesBtnText = document.getElementById('toggleImagesBtnText');
        var companyImageWrappers = document.querySelectorAll('.company-image-wrapper');
        var hiddenImages = Array.from(companyImageWrappers).slice(10); // Get images beyond the first 5
        var areImagesHidden = true; // Assume images are hidden initiall
        hiddenImages.forEach(function (wrapper) {
            if (isImageViewMore) {
                //@ts-ignore
                wrapper.style.display = 'flex';
                //@ts-ignore
                toggleImagesBtnText === null || toggleImagesBtnText === void 0 ? void 0 : toggleImagesBtnText.textContent = "View Less";
            }
            else {
                //@ts-ignore
                wrapper.style.display = '';
                //@ts-ignore
                toggleImagesBtnText === null || toggleImagesBtnText === void 0 ? void 0 : toggleImagesBtnText.textContent = "View More";
            }
        });
    });
});
function scrollToSession(sectionId) {
    var section = document.getElementById(sectionId);
    if (section && sectionId.indexOf("session") === 0) {
        section.scrollIntoView({ behavior: "smooth" });
    }
}
function scrollToSection(sectionId) {
    var section = document.getElementById(sectionId);
    if (section) {
        section.scrollIntoView({ behavior: "smooth" });
    }
}
function toggleNavbar() {
    var menu = document.querySelector(".navbar-menu");
    menu.classList.toggle("active");
}
function closeMenu(sectionId) {
    var menu = document.querySelector(".navbar-menu");
    scrollToSection(sectionId);
    menu.classList.remove("active");
}
function closeMenu2(sectionId) {
    var menu = document.querySelector(".navbar-menu");
    scrollToSession(sectionId);
    menu.classList.remove("active");
}
function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
}
var zero = function (n) {
    return ("0" + n).slice(-2);
};
var formatdate = function (datestr) {
    var date = new Date(datestr + "+09:00");
    return (date.getUTCFullYear() +
        zero(date.getUTCMonth() + 1) +
        zero(date.getUTCDate()) +
        "T" +
        zero(date.getUTCHours()) +
        zero(date.getUTCMinutes()) +
        zero(date.getUTCSeconds()) +
        "Z");
};
function createCalendar(title, start_time, end_time, day, speakerData) {
    var datefrom = "2024-06-05T" + start_time;
    var dateto = "2024-06-05T" + end_time;
    if (day === "day-2") {
        datefrom = "2024-06-06T" + start_time;
        dateto = "2024-06-06T" + end_time;
    }
    else if (day === "day-3") {
        datefrom = "2024-06-07T" + start_time;
        dateto = "2024-06-07T" + end_time;
    }
    var speaker = speakerData.split(',');
    var speaker_text = "";
    if (speaker.length > 0) {
        speaker.forEach(function (data) {
            speaker_text += data + "\n\n";
        });
    }
    window.open("http://www.google.com/calendar/event?action=TEMPLATE" +
        "&text=" +
        encodeURIComponent(title) +
        "&dates=" +
        formatdate(datefrom) +
        "/" +
        formatdate(dateto) +
        "&location=" +
        "https://spectacles2024.unerry.co.jp/" + "&details=＜登壇者＞%0A" + encodeURIComponent(speaker_text) + "———————————————————————%0A%0Aビッグデータカンファフェンス「SPECTACLEｓ〜 All you need is data [ ? ] 〜 」presented by unerry, Inc.%0A%0A▼イベント参加登録%0Ahttps://spectacles2024.unerry.co.jp"
        + "%0A%0A▼ログイン（登録済みの方）%0Ahttps://event.eventhub.jp/e/RtPgwSj8c/login", "_blank");
}
function sponsorRedirect(sponsorText) {
    if (sponsorText === "google") {
        window.open("https://cloud.google.com/?hl=ja", "_blank");
    }
    if (sponsorText === 'videoresearch') {
        window.open("https://www.videor.co.jp/");
    }
    if (sponsorText === 'nttbp') {
        window.open("https://www.ntt-bp.net/");
    }
}
function onRegister() {
    window.open("https://client.eventhub.jp/form/0592de51-8eb3-4f86-9fd8-3d51e3248c06/?isTicketSelected=true", "_blank");
}
function onClose(id) {
    var _a, _b;
    //@ts-ignore
    (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.style.visibility = 'hidden';
    //@ts-ignore
    (_b = document.getElementById(id)) === null || _b === void 0 ? void 0 : _b.style.opacity = 0;
}
function onModalClick(id) {
    var _a, _b;
    //@ts-ignore
    (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.style.visibility = 'visible';
    //@ts-ignore
    (_b = document.getElementById(id)) === null || _b === void 0 ? void 0 : _b.style.opacity = 1;
}
window.createCalendar = createCalendar;
window.onRegister = onRegister;
window.sponsorRedirect = sponsorRedirect;
window.scrollToSection = scrollToSection;
window.toggleNavbar = toggleNavbar;
window.closeMenu = closeMenu;
window.closeMenu2 = closeMenu2;
window.scrollToTop = scrollToTop;
window.onClose = onClose;
window.onModalClick = onModalClick;
